module.exports = __webpack_public_path__ + "static/media/AssistMedical.9a695f2e.svg";